<template>
  <div class="component-search-button">
    <div class="wrapper">
      <input
        type="text"
        v-model="text"
        class="text-secondary"
        :placeholder="placeholder"
      />
    </div>
    <button
      class="btn btn-40 btn-square text-secondary"
      :disabled="!text"
      @click="text = ''"
    >
      <i class="fs-18" :class="text ? 'icon-x' : 'icon-search'" />
    </button>
  </div>
</template>
<script>
let timeout;

export default {
  props: {
    initialSearch: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Pesquisar..."
    }
  },
  data() {
    return {
      text: this.initialSearch
    };
  },
  watch: {
    text(v) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.$emit("search", v);
      }, 300);
    }
  }
};
</script>
<style lang="scss" scoped>
.component-search-button {
  border: 1px solid rgba(155, 157, 176, 0.86);
  transition: 0.7s all;
  width: 100%;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  align-items: center;
  border-radius: 4px;

  button {
    border: none;
    border-radius: 3px;
  }
  .wrapper {
    width: 100%;
    input {
      border: none;
      border-radius: 4px;
      height: 40px;
      width: 100%;
      padding: 0 8px;
      background: transparent;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: rgba(119, 120, 142, 0.87);
      }
    }
  }
  &:focus-within {
    border: 1px solid #803fe1;
  }
}
</style>
